// CNCHome-Beyond · GA4 dataLayer global listeners
// add_to_cart / begin_checkout / form_submit

(function() {
  'use strict';

  function pushEvent(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data));
  }

  // ============== 1. add_to_cart ==============
  document.addEventListener('click', function(e) {
    var t = e.target;
    if (!t) return;
    var btn = t.closest('button[name="add"], .product-form__submit, [data-add-to-cart], input[name="add"]');
    if (!btn || btn.disabled) return;

    var form = btn.closest('form[action="/cart/add"], .product-form, form.product-form');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"], input[name="variant_id"]');
    var variantId = variantInput ? variantInput.value : '';
    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;

    var productTitle = form.querySelector('h1, .product__title, .product-title, [data-product-title]')?.textContent.trim()
                    || document.querySelector('h1, .product__title')?.textContent.trim()
                    || 'Unknown Product';
    var productPriceText = form.querySelector('.product__price, .price, [data-product-price]')?.textContent
                        || document.querySelector('.product__price, .price')?.textContent
                        || '0';
    var price = parseFloat(productPriceText.replace(/[^\d.]/g, '')) || 0;
    var productVendor = form.querySelector('[data-product-vendor]')?.textContent.trim() || '';
    var productType = form.querySelector('[data-product-type]')?.textContent.trim() || '';

    pushEvent('add_to_cart', {
      ecommerce: {
        currency: 'USD',
        value: price * qty,
        items: [{
          item_id: variantId || 'unknown',
          item_name: productTitle,
          item_brand: productVendor,
          item_category: productType,
          price: price,
          quantity: qty
        }]
      }
    });
  }, true);

  // ============== 2. begin_checkout ==============
  document.addEventListener('click', function(e) {
    var t = e.target;
    if (!t) return;
    var btn = t.closest('.cart__checkout-button, [name="checkout"], button.cart__submit, a.cart__checkout, form[action*="/checkout"] button, form[action*="/checkouts"] button');
    if (!btn) return;

    var lastCart = null;
    if (window.dataLayer) {
      for (var i = window.dataLayer.length - 1; i >= 0; i--) {
        if (window.dataLayer[i].event === 'view_cart') {
          lastCart = window.dataLayer[i].ecommerce;
          break;
        }
      }
    }

    pushEvent('begin_checkout', {
      ecommerce: lastCart || { currency: 'USD', value: 0, items: [] }
    });
  }, true);

  // ============== 3. form_submit ==============
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (form.matches('form[action="/cart/add"], form[action*="/search"]')) return;

    var isContactForm = form.matches('.contact-form, form.contact, form#contact_form, form[action*="/contact"]');
    var hasMessage = !!form.querySelector('textarea[name*="body"], textarea[name*="message"], textarea[name*="comment"], input[name*="subject"]');

    if (isContactForm || hasMessage) {
      var formId = form.id || form.getAttribute('name') || 'contact_form';
      if (form.action && form.action.indexOf('wholesale') > -1) formId = 'wholesale_inquiry';
      if (form.querySelector('input[name*="quote"]')) formId = 'quote_request';
      if (form.querySelector('input[name*="sample"]')) formId = 'sample_request';

      pushEvent('form_submit', { form_id: formId });
    }
  }, true);

})();